import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const CreateShopIndex = () => {
  const navigate = useNavigate();
  const { routePrefix } = useDashboardContext();

  useEffect(() => {
    navigate(`${routePrefix}/${ROUTE_KEYS.SHOP_FORM}/${ROUTE_KEYS.SHOP_FORM_DETAILS}`, {
      replace: true
    });
  }, []);
  return <div />;
};

export default CreateShopIndex;
